/**
 * J1 — Reiter-Definition der rechten Mail-Leiste.
 *
 * Rein und testbar: Reihenfolge und Beschriftungen liegen an EINER Stelle,
 * damit Rail (senkrechte Knöpfe) und Reiterkopf im Overlay nicht auseinander-
 * laufen. Die Icons bleiben in der Hülle (`MailContactSidebar.tsx`) — diese
 * Datei bleibt bewusst JSX-frei.
 */

export type SidebarTabKey =
    | "schriftwechsel"
    | "termine"
    | "vorgaenge"
    | "dokumente";

export type SidebarTab = { key: SidebarTabKey; label: string };

/** Kontext, der über die Sichtbarkeit einzelner Reiter entscheidet. */
export type SidebarTabsKontext = {
    /** Veraltet; bleibt vorerst für kompatible Aufrufer erhalten. */
    mailAdressierbar: boolean;
    /** J6 — der Dokumente-Reiter (kommt mit Cluster SEITENLEISTE PR 8). */
    dokumente?: boolean;
};

const BASIS: SidebarTab[] = [
    { key: "schriftwechsel", label: "Schriftwechsel" },
    { key: "termine", label: "Termine" },
    { key: "vorgaenge", label: "Vorgänge" },
];

const DOKUMENTE: SidebarTab = { key: "dokumente", label: "Dokumente" };

/**
 * Sichtbare Reiter in fester Reihenfolge:
 * Schriftwechsel → Termine → Vorgänge → Dokumente.
 */
export function sichtbareTabs(ctx: SidebarTabsKontext): SidebarTab[] {
    const out = [...BASIS];
    if (ctx.dokumente) out.push(DOKUMENTE);
    return out;
}

/** Beschriftung eines Reiters (leerer String bei unbekanntem Schlüssel). */
export function tabLabel(key: SidebarTabKey | null): string {
    if (key === null) return "";
    const all = sichtbareTabs({ mailAdressierbar: true, dokumente: true });
    return all.find((t) => t.key === key)?.label ?? "";
}
